import { useCallback, useEffect, useState } from 'react';
import { readPref, setPref, loadPrefs, onPrefChange } from '../services/prefsService';

/**
 * One per-account UI pref as React state: `[value, set]`. Reads the localStorage mirror
 * synchronously (no flash of the default), pulls the server copy once per session, and
 * follows writes made anywhere else on the page.
 */
export default function useUserPref(key) {
  const [value, setValue] = useState(() => readPref(key));
  useEffect(() => {
    const off = onPrefChange((k, v) => { if (k === key) setValue(v == null ? readPref(key) : v); });
    loadPrefs().then(() => setValue(readPref(key)));
    return off;
  }, [key]);
  const set = useCallback((next) => { setPref(key, next); }, [key]);
  return [value, set];
}
